import { DrEntity } from './dr-entity';
import { DrObject, DrObjectType, SupportedRegExType } from '../models/dr-object';

export enum Mode {
    READ = 'READ',
    READWRITE = 'READWRITE'
}

export enum Status {
    UNKNOWN = 'UNKNOWN',
    AVAILABLE = 'AVAILABLE',
    WARNING = 'WARNING',
    FAILURE = 'FAILURE',
    PARTIAL_FAILURE = 'PARTIAL_FAILURE',
    NOT_LICENSED = 'NOT_LICENSED'
}

export enum Type {
    Dummy = 'Dummy',
    FileSystem = 'FileSystem',
    NFS = 'NFS',
    CIFS = 'CIFS',
    SymantecEV = 'SymantecEV',
    Relativity = 'Relativity',
    Exchange = 'Exchange',
    Sharepoint = 'Sharepoint',
    GoogleWorkspace = 'GoogleWorkspace'
}

export enum MountedConnectorMode {
    CLASSIC = 'CLASSIC',
    PANFS = 'PANFS'
}

export enum CifsProtocol {
    NETBIOS = 'NETBIOS',
    FQDN_OR_IP = 'FQDN_OR_IP'
}

export enum CifsAuthentication {
    NONE = 'NONE',
    NTLM = 'NTLM',
    NTLMI = 'NTLMI',
    NTLMV2 = 'NTLMV2',
    NTLMV2I = 'NTLMV2I'
}

export class ConnectorViewModel extends DrObject {

    model: Partial<Connector>;

    constructor(value?: Partial<Connector>) {
        super(DrObjectType.CONNECTOR, SupportedRegExType.CONNECTOR);
        this.maxNameLength = 255;
        this.maxDescriptionLength = 255;

        if (value) {
            this.model = value;
        }
    }
}

// TODO: replace once we really refactor the ts file.
export class ConnectorBase extends DrEntity {
    name: string;
    description: string;

    constructor(value?: Partial<ConnectorBase>) {
        super(value);

        if (value) {
            Object.assign(this, value);
        }
    }
}

// TODO: need to move the parameters to those that should be shared across connectors
// and those specific to NFS/PANFS
export class Connector extends DrEntity {
    name: string;
    description: string;
    mode: Mode;
    modeDisplay: string;
    mountedConnectorMode: MountedConnectorMode;
    networkId: string;
    offset: string;
    remoteHost: string;
    remotePath: string;
    representationType: string;
    representationTypeDisplay: string;
    status: Status;
    type: Type;
    displayType: Type;
    domainController: string;
    dataSources: any[];

    constructor(value?: Partial<NFSConnector>) {
        super(value);

        if (value) {
            Object.assign(this, value);

            if (this.mode) {
                switch (this.mode) {
                    case Mode.READ: this.modeDisplay = 'Read'; break;
                    case Mode.READWRITE: this.modeDisplay = 'Read/Write'; break;
                }
            }

            if (this.remotePath && !this.remotePath.startsWith('/')) {
                this.remotePath = '/' + this.remotePath;
            }

            this.remoteHost = this.remoteHost && this.remoteHost.length > 0 ? this.remoteHost : this.networkId;
            this.remotePath = this.remotePath && this.remotePath.length > 0 ? this.remotePath : this.domainController;
        }
    }
}

export class NFSConnector extends ConnectorBase {

    constructor(value?: Partial<NFSConnector>) {
        super(value);

        if (value) {
            Object.assign(this, value);
        }
    }
}

export class CIFSConnector extends ConnectorBase {

    cifsProtocol: CifsProtocol = CifsProtocol.FQDN_OR_IP;
    cifsAuthentications = CifsAuthentication;
    cifsAuthentication: CifsAuthentication = CifsAuthentication.NTLM;
    cifsUsername: string;
    cifsPassword: string;
    cifsWorkgroupOrDomain: string;

    constructor(value?: Partial<CIFSConnector>) {
        super(value);

        if (value) {
            Object.assign(this, value);
        }
    }
}

export class ExchangeConnector extends ConnectorBase {
    azureActiveDirectory: boolean;
    exChangeUsername: string;
    exChangePassword: string;
    exChangeDomain: string;
    exChangetServer: string;
    exChangeTenantDomain: string;
    exChangeApplicationId: string;
    exChangeApplicationSecret: string;

    constructor(value?: Partial<ExchangeConnector>) {
        super(value);

        if (value) {
            Object.assign(this, value);
        }
    }
}

export class SharepointConnector extends ConnectorBase {
    sharepointUsername: string;
    sharepointPassword: string;
    sharepointDomain: string;
    sharepointServer: string;
    office365PublicOrPrivate: boolean;
    sharepointPublicSitesTenantDomain: string;
    sharepointPublicSitesApplicationId: string;
    sharepointPublicSitesApplicationSecret: string;
    sharepointPublicSitesRefreshToken: string;
    sharepointPrivateSitesTenantDomain: string;
    sharepointPrivateSitesApplicationId: string;
    sharepointPrivateSitesApplicationSecret: string;
    sharepointPrivateSitesRefreshToken: string;

    constructor(value?: Partial<SharepointConnector>) {
        super(value);

        if (value) {
            Object.assign(this, value);
        }
    }
}
